import { FC, forwardRef } from 'react';
import { IonIcon } from '@ionic/react';
import { AllieIconProps } from './Icon.types';
import { StyledIcon } from './Icon.styles';

export const AllieIcon: FC<AllieIconProps> = forwardRef((props, ref) => (
  <IonIcon ref={ref} mode={props.mode as any} {...props} />
));

export const AllieCustomIcon: FC<AllieIconProps> = ({
  allieColor,
  svg: SvgIcon,
  display,
  ...props
}) => {
  return (
    <StyledIcon allieColor={allieColor} display={display}>
      <SvgIcon {...props} allieColor={allieColor} />
    </StyledIcon>
  );
};
